<template>
  <div
    class="overlay"
    :class="{
      'is-visible': isVisible
    }"
    @click="handleClick"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "Overlay",
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/color-theme';

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($black, 0.8);
    visibility: hidden;
    opacity: 0;
    z-index: 2;
    transition: all .2s;

    &.is-visible {
      visibility: visible;
      opacity: 1;
      transition: all .2s;
    }
  }
</style>
